import { DAYS, HOURS, MINUTES, SECONDS } from './constants';

export const calculateTime = (dt: string) => {
  const countdownDate = new Date(dt).getTime();

  const now = new Date().getTime();
  const timeDifference = countdownDate - now;

  const days = Math.floor(timeDifference / DAYS);
  const hours = Math.floor((timeDifference % DAYS) / HOURS);
  const minutes = Math.floor((timeDifference % HOURS) / MINUTES);
  const seconds = Math.floor((timeDifference % MINUTES) / SECONDS);

  return {
    timeDifference,
    days,
    hours,
    minutes,
    seconds,
  };
};
